<template>
  <div id="app" class="app">
    <Header v-if="!miniLayout" />
    <router-view v-if="status === 200" class="view" />
    <ErrorPage v-else :status="status" />
    <to-top v-if="showToTop" />
    <Footer :location="miniLayout ? 'footer_menu_checkout' : 'footer_menu'" />
    <GlobalSearch v-if="!miniLayout" />
    <QuickView />
    <Notifications />
    <auth-modal />
    <city-modal />
    <city-confirmation-modal />
    <cookies-modal />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import appScripts from '@/utils/app-scripts';
import './assets/scss/app.scss';

/* Components */
import Header from './components/header/index';
import Footer from './components/footer/index';
import GlobalSearch from './components/search/global-search';
import Notifications from './components/notifications/notifications.vue';
import ErrorPage from './pages/error';
import ToTop from './components/to-top/to-top.vue';
import QuickView from './components/product/quickview.vue';
import AuthModal from '@/components/common/auth-modal.vue';
import CityModal from './components/common/city-modal.vue';
import CookiesModal from './components/common/cookies-modal';
import CityConfirmationModal from './components/common/city-confirmation-modal';

export default {
  name: 'App',

  components: {
    CityConfirmationModal,
    CookiesModal,
    Header,
    Footer,
    GlobalSearch,
    Notifications,
    ErrorPage,
    ToTop,
    QuickView,
    AuthModal,
    CityModal,
  },
  
  inject: ['adaptive'],

  metaInfo() {
    const scripts = process.env.NODE_SERVER !== 'dev' ? appScripts : {};

    const link = [];
    const meta = [
      {
        vmid: 'charset',
        charset: 'utf-8',
        once: true,
      },
      {
        vmid: 'viewport',
        name: 'viewport',
        content: 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1',
        once: true,
      },
    ];

    this.SEO.description && meta.push({
      vmid: 'description',
      name: 'description',
      content: this.SEO.description,
    });

    this.SEO.canonical && link.push({
      vmid: 'canonical',
      rel: 'canonical',
      href: this.SEO.canonical,
    });

    return {
      titleTemplate: t => `${t && t + ' — '}Официальный интернет-магазин Funday`,
      title: this.SEO.title,
      meta,
      link,
      ...scripts,
    };
  },

  computed: {
    ...mapState({
      SEO: state => state.seo.seo,
    }),
    ...mapGetters({
      status: 'config/status',
    }),

    miniLayout() {
      return ['Checkout'].includes(this.$route.name);
    },
    showToTop() {
      return ['Product', 'Catalog', 'Category'].includes(this.$route.name);
    },
  },
  mounted() {
    this.$f.initClient();
  },
  created() {
    if(this.$isServer) return;
    
    this.adaptive.initMatchMedia();
  },
  async serverPrefetch() {
    this.SET_STATUS(this.$ssrContext.status);
    if (this.$ssrContext.cookies.CITY_ID) {
      this.SET_CITY_ID(this.$ssrContext.cookies.CITY_ID);
      this.CONFIRM_CITY();
    }

    // Здесь асинхронно только аккаунт! Используется для перевыпуска токена
    await this.GET_ACCOUNT();

    return this.LOAD_SEO({ url: this.$route.path });
  },
  methods: {
    ...mapActions({
      GET_ACCOUNT: 'user/getAccount',
      LOAD_SEO: 'seo/loadSeo',
    }),
    ...mapMutations({
      SET_CITY_ID: 'user/setCityId',
      CONFIRM_CITY: 'user/cityConfirmed',
      SET_STATUS: 'config/setStatus',
    }),
  },
}
</script>

<style lang="scss">
.app {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 100%;
  .view {
    margin-bottom: 80px;
  }
  .footer {
    margin-top: auto;
  }
}

@include breakpoint("desktop") {
  .app {
    .view {
      margin-bottom: 120px;
    }
  }
}

</style>
